import { applyMiddleware, combineReducers, createStore } from 'redux';
import { createReduxHistoryContext } from 'redux-first-history';
import rootReducer from 'reducers/index';
import { createBrowserHistory } from 'history';
import thunkMiddleware from 'redux-thunk';
// import loggerMiddleware from 'redux-logger'
const browserHistory = createBrowserHistory();
const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
    history: browserHistory,
});
const middlewares = [thunkMiddleware, routerMiddleware];
// if (process.env.NODE_ENV !== 'production') {
//   middlewares.push(loggerMiddleware)
// }
export const store = createStore(combineReducers({
    router: routerReducer,
    rootReducer: rootReducer,
}), applyMiddleware(...middlewares));
export const history = createReduxHistory(store);
